<script>
  import { classnames } from '@client/utils/classnames';

  /**
   * Additional CSS class name for the component
   * @type {string}
   * @default ''
   */
  let className = '';
  export { className as class };

  export let title = undefined;

  $: classes = classnames(className, 'section');
</script>

{#if title}
  <h3>{title}</h3>
{/if}

<div class={classes}>
  <slot />
</div>

<style lang="scss" src="./section.scss"></style>
